// extracted by mini-css-extract-plugin
module.exports = {"confirmation":"success-page_confirmation__VeG_H","container":"success-page_container__zEY-3"};